import { stdObject } from "../../../../data/types/stdObject";

export const closeStationery = async (
  close: boolean | string = false,
  params: stdObject,
) => {
  const {
    docValues,
    setDocValues,
    setStationeryModal,
    setMsg,
    documentAction,
    openWindow,
    closeMsg,
  } = params;
  if (!close && docValues.updated) {
    setMsg("askToClose");
  } else {
    if ("action" in documentAction.current) {
      openWindow({
        msgName: "document",
        modalInfo: {
          doc: docValues.type,
          code: docValues.documentData[`COD${docValues.type}`],
          serie: docValues.documentData[`SER${docValues.type}`],
          mainColor: docValues.mainColor,
          type: docValues.sectionId,
          typeText: docValues.typeText,
        },
        level: 0,
      });
      documentAction.current = {};
    } else {
      setDocValues({});
    }
    setStationeryModal("");
    closeMsg();
  }
};
